import { setIsLoading } from '../../../../../actions/general';
import { callApi } from '../../../../../apiCaller';
import { API_SUBSCRIBER_LIST_ORGANIZATION_BUNDLE_SEATS } from '../../../../../constants';
import { toastError } from '../../../../../utils';

const API_SUBSCRIBER_ORGANIZATION_SEATS_FILTER = 'seat/:organizationId';
const API_SUBSCRIBER_LIST_ORGANIZATION_SEATS = 'seat/organization/:organizationId';

export const SET_ORGANIZATIONS_SEATS_FILTER = 'setOrganizationSeatsFilter';
export const SET_LIST_ORGANIZATIONS_SEATS = 'setListOrganizationSeats';
export const SET_LIST_ORGANIZATIONS_BUNDLE_SEATS = 'setListOrganizationBundleSeats';

export const setOrganizationSeatsFilter = (organizationSeatsFilter) => {
     return {
          type: SET_ORGANIZATIONS_SEATS_FILTER,
          payload: organizationSeatsFilter,
     };
};

export const setListOrganizationSeats = (listOrganizationSeats) => {
     return {
          type: SET_LIST_ORGANIZATIONS_SEATS,
          payload: listOrganizationSeats,
     };
};

export const setListOrganizationBundleSeats = (listOrganizationBundleSeats) => {
     return {
          type: SET_LIST_ORGANIZATIONS_BUNDLE_SEATS,
          payload: listOrganizationBundleSeats,
     };
};

export const fetchOrganizationSeatsByFilterRequest =
     ({ organizationId, query, setOrgNotCourses, setOrgUserSeats }) =>
     async (dispatch) => {
          let urlApi = `${API_SUBSCRIBER_ORGANIZATION_SEATS_FILTER.replace(':organizationId', organizationId)}`;

          // Add query into url api
          if (Object.keys(query).length > 0) {
               const queryArray = [];

               Object.keys(query).forEach((key) => {
                    if (query[key]) {
                         queryArray.push(`${key}=${query[key]}`);
                    }
               });

               if (queryArray.length > 0) {
                    urlApi += '?' + queryArray.join('&');
               }
          }

          dispatch(setIsLoading(true));
          return await callApi(urlApi, 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         if (typeof setOrgUserSeats === 'function') {
                              setOrgUserSeats(response.data);
                         } else {
                              dispatch(setOrganizationSeatsFilter(response.data));
                         }

                         if (!response.data.length && typeof setOrgNotCourses === 'function') {
                              setOrgNotCourses(true);
                         }
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    dispatch(setIsLoading(false));
               });
     };

export const fetchListOrganizationSeatsRequest = (organizationId) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_LIST_ORGANIZATION_SEATS.replace(':organizationId', organizationId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setListOrganizationSeats(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const fetchListOrganizationBundleSeatsRequest = (organizationId, setOrgNotCourses) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_LIST_ORGANIZATION_BUNDLE_SEATS.replace(':organizationId', organizationId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setListOrganizationBundleSeats(response.data));

                    if (!response.data.length && setOrgNotCourses) {
                         setOrgNotCourses(true);
                    }
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
